import React from "react";
import clsx from "clsx";

import { IconButton } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { withStyles, createStyles } from "@mui/styles";
import { DATE_FORMAT } from "utils/helper";

const CustomElements = ({ classes, date, setDate }) => {
  // const formatWeekSelectLabel = (invalidLabel) => {
  //   if (!date || !dayjs(date).isValid()) {
  //     return invalidLabel;
  //   }

  //   const currentWeekOfMonth = dayjs().date() / 7; // Calculate based on the current day of the month
  //   const weekOfMonth = Math.ceil(currentWeekOfMonth); // Round up to get the correct week number
  //   return `Week No. ${weekOfMonth} of ${dayjs(date).format("MMMM")}`;
  // };

  const renderWrappedWeekDay = (weekDay) => {
    const actualDate = dayjs(weekDay.day); // Convert the date.day string to a dayjs object
    const selectedDate = dayjs(date);
    const startOfWeek = selectedDate ? selectedDate.startOf("week") : dayjs();
    const endOfWeek = selectedDate ? selectedDate.endOf("week") : dayjs();

    // Check if the day is within the selected week
    const isWithinSelectedWeek = actualDate.isBetween(
      startOfWeek,
      endOfWeek,
      null,
      "[]"
    );

    const dayInCurrentMonth = actualDate.isSame(
      dayjs(actualDate).startOf("month"),
      "month"
    );

    const wrapperClassName = clsx({
      [classes.highlight]: isWithinSelectedWeek,
    });

    const dayClassName = clsx(classes.day, {
      [classes.nonCurrentMonthDay]: !dayInCurrentMonth,
      [classes.highlightNonCurrentMonthDay]:
        !dayInCurrentMonth && isWithinSelectedWeek,
    });

    const handleDayClick = () => {
      setDate(actualDate.startOf("week"));
    };

    return (
      <div className={wrapperClassName}>
        <IconButton className={dayClassName} onClick={handleDayClick}>
          <span>{actualDate.format("D")}</span>
        </IconButton>
      </div>
    );
  };

  return (
    <DatePicker
      value={dayjs(date)}
      onChange={(e) => console.log("date>>>: ", e)}
      slots={{ day: renderWrappedWeekDay }}
      slotProps={{ textField: { variant: "standard" } }}
      format={DATE_FORMAT}
    />
  );
};

const styles = createStyles(() => ({
  dayWrapper: {
    position: "relative",
  },
  day: {
    width: 36,
    height: 36,
    fontSize: "14px",
    margin: "0 2px",
    color: "inherit",
  },
  customDayHighlight: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: "2px",
    right: "2px",
    border: `1px solid #d91a5f`,
    borderRadius: "50%",
  },
  nonCurrentMonthDay: {
    color: "#9E9E9E",
  },
  highlightNonCurrentMonthDay: {
    color: "#ffffff",
  },
  highlight: {
    background: "#cb3366",
    color: "#ffffff",
  },
  firstHighlight: {
    extend: "highlight",
    borderTopLeftRadius: "50%",
    borderBottomLeftRadius: "50%",
  },
  endHighlight: {
    extend: "highlight",
    borderTopRightRadius: "50%",
    borderBottomRightRadius: "50%",
  },
}));

export default withStyles(styles)(CustomElements);
